<template>
  <div>
    <NpsSurveyBottomSheet />
    <Teleport to="body">
      <div class="fixed z-10 flex w-full justify-center">
        <FreeAlertWithUseAlert
          :use-alert="useAlert"
          :icons="{
            heart: h('img', { src: HeartIcon }),
          }"
          class="bottom-28 mx-4"
        >
          <template #default="{ content }">
            <div class="text-text-neutral-primary">
              {{ content.message }}
            </div>
          </template>
        </FreeAlertWithUseAlert>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
  import { h } from 'vue';
  import { controllerModel } from 'shared';
  import { FreeAlertWithUseAlert } from 'freedom-shared';

  import {
    NpsSurveyBottomSheet,
    NPS_SURVEY_BOTTOM_SHEET_NAME,
  } from '@/entities/nps-survey';

  import { useBloomreachTrigger } from '@/shared/lib/bloomreach-bridge';
  import { bloomreachEventsConfig, bloomreachLib } from '@/shared/lib';
  import { useAlert } from '@/shared/ui';

  import HeartIcon from '@/assets/images/heart-icon.svg?url';

  const bottomSheet = controllerModel.useBottomSheet();

  useBloomreachTrigger(
    message => {
      const { payload } = message;
      bottomSheet.show(NPS_SURVEY_BOTTOM_SHEET_NAME, payload);
      bloomreachLib.track(
        bloomreachEventsConfig.BloomreachEventName.NPS_SURVEY_SHOWN,
      );
    },
    { eventType: 'NPS_SURVEY' },
  );
</script>
